export enum EnumNotificationType {          // tương ứng với giá trị quy ước trên backend
  RESET_PASSWORD = 5,
  DIGITAL = 82,
  SIGN_WAIT = 90,
  CREATE_ACCOUNT = 6,
  SIGN_MULTI_SUCCESS = 7,
  SIGN_MULTI_CANCEL = 8,
  CANCEL_SIGN_FLOW = 17,
  CREATE_CONTRACT_LOT = 39,
  IMPORT_USER_FILE = 41,                  //thêm người dùng từ file
  IMPORT_CUSTOMER_FILE = 42,              //thêm khách hàng từ file
  CONTRACT_PERSONAL_CREATE = 43,          //hợp đồng tôi lập
  CONTRACT_ENTERPRISE_CREATE = 44,        //hợp đồng công ty lập
  CONTRACT_ENTERPRISE_RECEIVE = 45,       //hợp đồng công ty nhận
  TOTAL_CONTRACT_REPORT = 46,             //số lượng hợp đồng
  // TOTAL_CONTRACT_REPORT_BY_USER = 46,             //số lượng hợp đồng User lập
  SMS_QUANTITY_REPORT = 47,               //số lượng tin nhắn
  SMS_MONEY_REPORT = 48,                  //tiền tin nhắn đã sử dụng

  CONTRACT_PERSONAL_CREATE_ERROR = 49,          //hợp đồng tôi lập
  CONTRACT_ENTERPRISE_CREATE_ERROR = 50,        //hợp đồng công ty lập
  CONTRACT_ENTERPRISE_RECEIVE_ERROR = 51,       //hợp đồng công ty nhận
  TOTAL_CONTRACT_REPORT_ERROR = 52,             //số lượng hợp đồng
  // TOTAL_CONTRACT_REPORT_BY_USER_ERROR = 52,             //số lượng hợp đồng
  SMS_QUANTITY_REPORT_ERROR = 53,               //số lượng tin nhắn
  SMS_MONEY_REPORT_ERROR = 54,                  //tiền tin nhắn đã sử dụng

  SIGN_MULTI_FLOW_SUCCESS = 55,
  SIGN_MULTI_FLOW_STOP = 56,

  DELETE_MULTI_FLOW_SUCCESS = 92,
  DELETE_MULTI_FLOW_STOP = 93,

  CERTIFICATE_MONEY_SUCCESS = 57,    //tiền chứng thực đã sử dụng
  TIMESTAMP_QUANTITY_SUCCESS = 58,      //Số dấu thời gian đã sử dụng

  CERTIFICATE_MONEY_ERROR = 59,    //tiền chứng thực đã sử dụng
  TIMESTAMP_QUANTITY_ERROR = 60,      //Số dấu thời gian đã sử dụng

  EXPORT_CUSTOMER_SUCCESS = 62, // xuất dữ liệu KH thành công
  EXPORT_CUSTOMER_ERROR = 63, // xuất dữ liệu KH thất bại

  DONE_INITIAL_WAIT_APPROVE = 65, // đã ký duyệt hợp đồng. Hợp đồng đang Chờ xác nhận
  DONE_INITIAL_WAIT_APPROVE_CUSTOMER = 66, // đã ký duyệt hợp đồng. Hợp đồng đang Chờ xác nhận
  NEED_APPROVE = 67, // đã gửi yêu cầu ký xác nhận hợp đồng
  DONE_SIGN_APPROVE = 68, // đã ký xác nhận và hoàn thành hợp đồng
  DONE_SIGN_APPROVE_CUSTOMER = 69, // đã ký xác nhận và hoàn thành hợp đồng

  CANCEL_SIGN_APPROVE_CUSTOMER = 70, // đã ký xác nhận và hoàn thành hợp đồng
  NOTIFICATION_TRANSFER_MONEY_STA_TO_SMS_SUCCESS = 79, // Thông báo chuyển tiền từ chứng thực sang sms
  NOTIFICATION_TRANSFER_MONEY_SMS_TO_STA_SUCCESS = 80,  // Thông báo chuyển tiền từ sms sang chứng thực
  RESULT_SYNC_CUSTOMER = 71, // kết quả đồng bộ hợp đồng
  APPROVE_MULTI_SUCCESS = 75, // duyệt hợp đồng theo lô
  APPROVE_MULTI_CANCEL = 76, // hủy duyệt hợp đồng theo lô
  DECLINE_MULTI_SUCCESS = 77, // từ chối duyệt hợp đồng theo lô
  DECLINE_MULTI_CANCEL = 78, // hủy từ chối duyệt hợp đồng theo lô
  CANCEL_FLOW_SUCCESS = 84,
  CANCEL_FLOW_CANCEL = 85,
  CONFIRM_FLOW_SUCCESS = 86,
  CONFIRM_FLOW_CANCEL = 87,
  REPORT_USER_SUCCESS = 88,
  REPORT_USER_ERROR = 89,
  CREATE_NEGOTIATE_CONTRACT = 95,
  UPDATE_NEGOTIATE_CONTRACT = 96,
  ADD_NEW_NEGOTIATE_COMMENT = 97,
  CONTRACT_SHARE_PARTNER = 98,
  CONTRACT_LIQUIDATION_SUCCESS = 103,
  REPORT_PROCESSING_ERROR = 105,
  REPORT_PROCESSING_SUCCESS = 106,
  SIGN_MULTI_SUCCESS_DIGITAL = 99,
  SIGN_MULTI_CANCEL_DIGITAL = 100,
  REFUND_RESOURCE = 107,
  VIEW_DOCUMENT_MOHA_DIGITAL = 114,
  CREATE_CONTRACT_LOT_DIGITAL = 121,
}
